import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Button, Text } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'

const StyledContainer = styled.div`
  text-align: center;
  position: relative;
`;

const Content = styled.div`
  display: inline-block;
  background: ${({ theme }) => (theme.isDark ? 'rgb(44, 41, 38)' : 'white')};
  box-shadow: 2px 2px 8px ${({ theme }) => (theme.isDark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)')};
  border-radius: 32px;
  padding: 30px 25px;
  position: relative;
  width: 600px;

  @media (max-width: 650px) {
    width: 100%;
    padding: 30px 15px;
  }
`

const Row = styled.div`
    margin-top: 25px;
`;

const Actions = styled.div`
    display: inline-block;
    max-width: 500px;
    margin-top: 50px;

    &>button, &>a {
        margin:5px;
    }
`

interface SuccessfulProps {
    onConfirm?: any
}

const Successful: React.FC<SuccessfulProps> = ({ onConfirm }) => {
    const TranslateString = useI18n();
    return (
        <StyledContainer>
            <div>
                <Content>
                    <div>
                        <img src="/images/checked.png" alt="Successful" width="128" height="128" style={{width:128,height:128}}/>
                    </div>
                    <Row>
                        <Text>
                          {TranslateString(1063,'Congratulations! You have successfully created a token!')}
                        </Text>
                    </Row>
                    <Actions>
                        <Button onClick={onConfirm}>
                          {TranslateString(1064,'Create More')}
                        </Button>
                    </Actions>
                </Content>
            </div>
        </StyledContainer>
    )
}

export default Successful
 